import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__global_reset } from '@/state/_base/LOCAL__global_reset';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function BUTTON__try_app() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const dispatch = use_dispatch();
  const navigate = useNavigate();

  /*
   * EVENTS
   */
  async function onClick() {
    dispatch(LOCAL__global_reset());

    await navigate(ENUM__page_type.AUTH);
  }

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__button className="w-80 min-w-[17.5rem] h-9" variant="outline-on-bar" {...{ onClick }}>
      {t(i18n_base_ui.button.try_app.title)}
    </UI_PRIMITIVE__button>
  );
}
